export class User {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  token: string;
  refreshToken: string;

  constructor(id: string, username: string, firstName: string, lastName: string, token: string, refreshToken: string) {
    this.id = id;
    this.username = username;
    this.firstName = firstName;
    this.lastName = lastName;
    this.token = token;
    this.refreshToken = refreshToken;
  }
}
